import { BeatLoader } from "react-spinners";
import { Typography as T } from "@mui/material";
import { styled } from "@mui/material/styles";

interface Props {
  color?: string;
  size?: string;
  hideText?: boolean;
  text?: string;
}

const LoaderContainer = styled("div")({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

const Loader = ({ color, size, hideText, text }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center w-100 h-100">
      <div className="flex flex-col items-center">
        <LoaderContainer>
          <BeatLoader size={size ? size : "16px"} color={color} />
        </LoaderContainer>
        {!hideText && (
          <T variant="lgReg" style={{ textAlign: "center" }}>
            {text ? text : "This may take a few moments..."}
          </T>
        )}
      </div>
    </div>
  );
};

export default Loader;
